export function validateImageFile(file, t) {
  if (!file) return t("administration.imageManagement.fileRequired");

  const allowedTypes = ["image/png"];

  if (!allowedTypes.includes(file.type)) {
    return t("administration.imageManagement.pngOnly");
  }

  const maxSize = 5 * 1024 * 1024; // 5MB

  if (file.size > maxSize) {
    return t("administration.imageManagement.fileUnder5Mb");
  }

  return null;
}
